import {onboardingGoingLiveBeforeServicing} from '@client/remote-config';
import {Route, NavigationGuardNext} from 'vue-router';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const onboardingLiveBeforeServicing = async () => {
  const onboardingBeforeServicing = await onboardingGoingLiveBeforeServicing();

  return onboardingBeforeServicing;
};

export enum DocVaultRouteNames {
  DocVaultPage = 'DocVaultPage',
}

export default [
  {
    path: '/clientdashboard/docvault',
    beforeEnter: async (_to: Route, _from: Route, next: NavigationGuardNext): Promise<void> => {
      if (await onboardingLiveBeforeServicing()) {
        window.location.href =
          process.env.VUE_APP_ENV === 'prod'
            ? 'https://advisedservices.individuals.principal.com'
            : 'https://advisedservices.individuals.staging.principal.com';
      }

      // eslint-disable-next-line callback-return
      next();
    },
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    component: () => import('@client/layouts/authenticated/Index.vue'),
    meta: {
      useLayouts: true,
    },
    children: [
      {
        path: '',
        name: DocVaultRouteNames.DocVaultPage,
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        component: () => import('@client/pages/docVault/DocVaultPage.vue'),
        meta: {
          useLayouts: true,
        },
      },
    ],
  },
];
